import { render, staticRenderFns } from "./BaseLineTableCodDescription.vue?vue&type=template&id=27181dd0&"
import script from "./BaseLineTableCodDescription.vue?vue&type=script&lang=js&"
export * from "./BaseLineTableCodDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports